import { render, staticRenderFns } from "./DynamicCreate.vue?vue&type=template&id=77c8d6de&scoped=true&"
import script from "./DynamicCreate.vue?vue&type=script&lang=js&"
export * from "./DynamicCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c8d6de",
  null
  
)

export default component.exports